module.exports = __webpack_public_path__ + "img/happy-holidays-text.e52c333d.png";